<template>
  <div>
    <v-card class="mt-5">
      <v-data-table
        :headers="report.headers"
        :items="report.items"
        :items-per-page="20"
        :loading="loading"
        single-expand
        :expanded.sync="expanded"
        loading-text="Загрузка..."
        no-data-text="Ничего не найдено"
        item-key="id"
        :page.sync="page"
        @click:row="openRow"
        @page-count="pageCount = $event"
        hide-default-footer
      >
        <template #expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <h4 v-if="item.content.length > 0" class="my-4">Анкета</h4>
            <v-simple-table
              v-if="item.content.length > 0"
              class="mb-6"
              style="max-width: fit-content;"
              dense
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Вопрос
                    </th>
                    <th class="text-left">
                      Ответ
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="formItem in item.content"
                    :key="formItem.code + utils.randomString()"
                  >
                    <td>{{ formItem.title }}</td>
                    <td>{{ formItem.value }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <h4 v-if="item.content.length === 0">Нет данных...</h4>
          </td>
        </template>

        <template #top>
          <v-row>
            <v-col cols="auto">

              <v-badge
                v-if="callsCount !== null"
                class="mt-2 mx-2"
                bordered
                color="info"
                overlap
              >
                <v-chip
                  color="info"
                  label
                  outlined
                >Всего вызовов</v-chip>

                <template #badge>{{ callsCount }}</template>
              </v-badge>

              <v-badge
                v-if="filledFormsCount !== null"
                class="mt-2 ml-7"
                bordered
                color="info"
                overlap
              >
                <v-chip
                  color="info"
                  label
                  outlined
                >Всего вызовов с карточками</v-chip>

                <template #badge>{{ filledFormsCount }}</template>
              </v-badge>

            </v-col>

            <v-col v-if="pageCount > 1" cols="4">
              <v-pagination
                v-model="page"
                :length="pageCount"
                :total-visible="7"
              ></v-pagination>
            </v-col>
          </v-row>
        </template>

        <template #[`item.sending_status`]="{item}">
          <v-menu
            left
            :close-on-content-click="false"
            min-width="300px"
            max-width="500px"
            max-height="60vh"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-if="item.sending_status === 'ok'"
                color="green"
                v-bind="attrs"
                v-on="on"
              >mdi-check</v-icon>
              <v-icon
                v-else-if="item.sending_status === 'bad'"
                color="red"
                v-bind="attrs"
                v-on="on"
              >mdi-cancel</v-icon>
              <v-icon
                v-else-if="item.sending_status === 'warning'"
                color="orange"
                v-bind="attrs"
                v-on="on"
              >mdi-exclamation-thick</v-icon>
            </template>

            <v-sheet
              v-for="(resp, index) in item.sending_results"
              :key="`resp_${index}`"
              class="pa-2 mb-4"
            >
              <v-row>
                <v-col cols="3">
                  <v-chip>{{resp.type_sending}}</v-chip>
                </v-col>
                <v-col cols="9" class="text-end">
                  <v-icon v-if="resp.status" color="green">mdi-check</v-icon>
                  <v-icon v-else color="red">mdi-cancel</v-icon>
                </v-col>
              </v-row>
              <v-alert
                border="left"
                colored-border
                :type="resp.status ? 'info' : 'error'"
                class="mt-2"
                style="word-wrap: anywhere;"
              > {{resp.response}} </v-alert>
              <hr>
            </v-sheet>
          </v-menu>
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip v-if="item.uid" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                :href="callUrl(item.uid)"
                target="_blank"
                v-on="on"
                v-bind="attrs"
              >
                <v-icon dense>mdi-dock-window</v-icon>
              </v-btn>
            </template>
            <span>Просмотреть звонок (в новой вкладке)</span>
          </v-tooltip>

        </template>

        <template #footer>
          <v-row v-if="pageCount > 1">
            <v-col cols="1"></v-col>
            <v-col cols="4">
              <v-pagination
                v-model="page"
                :length="pageCount"
                :total-visible="7"
              ></v-pagination>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'FormList',

  data() {
    return {
      report: {
        headers: [
          {text: 'Дата', value: 'date'},
          {text: 'Оператор', value: 'operator'},
          {text: 'Номер клиента', value: 'phone_number'},
          {text: 'Хелпер', value: 'helper_name'},
          {text: 'Форма', value: 'form_name'},
          {text: 'Источник', value: 'start_exten'},
          {text: 'Статус', value: 'sending_status'},
          {text: '', value: 'actions'},
        ],
        items: [],
      },
      expanded: [],
      page: 1,
      pageCount: 0,
      callsCount: null,
      filledFormsCount: null,
    }
  },

  computed: {
    ...mapGetters({
      loading: 'shared/getLoading',
      formReport: 'form_report/report',
    }),
  },

  methods: {
    ...mapActions({
      resetAllState: 'resetAllState',
      loadFormReport: 'form_report/loadFormReport',
      loadRatioCallsToCards: 'form_report/loadRatioCallsToCards',
    }),

    openRow(item, context) {
      context.expand(!context.isExpanded);
    },

    callUrl(uid) {
      return `${process.env.VUE_APP_API_DOMAIN}${this.$router.resolve({
        name: 'SpeechAnalysisCall',
        params: {uid}
      }).href}`
    },

    async loadReport(payload) {
      for (let key in payload) {
        if (!payload[key]) {
          delete payload[key];
          continue;
        }

        if (payload[key].length === 0) delete payload[key];
      }

      this.callsCount = null
      this.filledFormsCount = null
      this.loadRatioCallsToCards(payload)
        .then(resp => {
          this.callsCount = resp.calls_count
          this.filledFormsCount = resp.filled_forms_count
        })

      let res = await this.loadFormReport(payload)

      if (Array.isArray(res)) {
        this.report.items = res.map((item, index) => {
          return {...item, id: index}
        })
      }
    },
  },

  mounted() {},

  beforeDestroy() {
    this.resetAllState();
  },
}
</script>

<style scoped></style>
